export default __webpack_public_path__ + "static/media/new-gogreen-page-banner-rr.8e4c63b3.jpg";